import {ACTION_CODE} from './_actionCode';
import {DashboardService} from '../../../services';
import {ErrorModel, ResultModel} from '../../../models';
import {LoggerService} from '../../../services';
const FUNCTION_CODE = 'GET_EXPENSES';

export async function getExpenses(userData: Record<string, any>, params: Record<string, any>) {
    try {
        LoggerService.logInfo('Action - getExpenses - Start');

        const getExpenses =
            await DashboardService.OfficeManagerService.getExpenses(userData, params);

        LoggerService.logInfo('Action - getExpenses - End - Success');

        return ResultModel.newSuccessResult(getExpenses);
    }
    catch (error) {
        LoggerService.logInfo('Action - getExpenses - End - Error');
        const newErr = ErrorModel.newError({
            code: `${ACTION_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue.',
            error: error
        });
        LoggerService.logError(error);

        return ResultModel.newErrorResult(newErr);
    }
}
